<ui-card [loading]="isLoading">
    <app-segment-header title="time-tracking.payrollIntegrationCardComponent.header">
        <div class="buttons">
            <ui-button type="link" [routerLink]="['./payroll-integration']">
                {{ 'edit' | translate }}
                <span class="sr-only">{{ 'time-tracking.payrollIntegrationCardComponent.header' | translate }}</span>
            </ui-button>
        </div>
    </app-segment-header>

    <ng-container *ngIf="this.settings.payrollIntegration">
        <div class="app-grid center">
            <div class="columns-2">{{ 'time-tracking.payrollIntegrationCardComponent.transferHours' | translate }}</div>
            <div class="columns-1">{{ 'yes' | translate }}</div>
        </div>
        <div class="app-grid center margin-top-3">
            <div class="columns-2 margin-bottom-0">
                {{ 'time-tracking.payrollIntegrationCardComponent.hourTypesEnabled' | translate }}
            </div>
            <div class="columns-10" *ngIf="incomeTypes.length > 0">
                <mat-chip-listbox>
                    <ng-container *ngFor="let incomeType of incomeTypes"
                        ><mat-chip-option *ngIf="incomeType.enabled">
                            {{ incomeType.displayName }}</mat-chip-option
                        ></ng-container
                    >
                </mat-chip-listbox>
            </div>
            <div class="app-grid center margin-top-3">
                <div class="columns-2">
                    {{ 'time-tracking.payrollIntegrationCardComponent.hourlyEmployees' | translate }}
                </div>
                <div class="columns-1">{{ payrollEmployeesCount }}</div>
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="!this.settings.payrollIntegration">
        <div class="app-grid">
            <p class="columns-2">{{ 'time-tracking.payrollIntegrationCardComponent.transferHours' | translate }}</p>
            <p class="columns-1">{{ 'no' | translate }}</p>
        </div>
    </ng-container>
</ui-card>
